import { getDevLandingPageNumber } from '@/config/config'

/**
 * Dev-only landing page override. Opens the editor on the spread containing a specific yearbook
 * page number, via VITE_DEV_LANDING_PAGE_NUMBER. Gated on import.meta.env.DEV — true only for the
 * Vite dev server, never for any `vite build` output (dev/qat/prod modes alike) — so this is dead
 * code outside local development. Resolving the page number to a spread index requires the loaded
 * spreads list, so this only reports whether an override is configured; `home.tsx`'s spread-restore
 * effect performs the actual lookup via `findSpreadIndexForPageNumber` once spreads are available.
 */
export function isDevLandingPageOverrideConfigured(): boolean {
  return import.meta.env.DEV && getDevLandingPageNumber() > 0
}
